import { render, staticRenderFns } from "./EnviarComprobantes.vue?vue&type=template&id=c8cdfbe4&scoped=true&"
import script from "./EnviarComprobantes.vue?vue&type=script&lang=js&"
export * from "./EnviarComprobantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cdfbe4",
  null
  
)

export default component.exports